<template>
  <div class="filter-accordion">
    <div class="filter-accordion__header">
      <h2 v-if="selectedFiltersCount > 0" aria-live="polite">
        {{ initialData.dictionary.filterTitle }} ({{ selectedFiltersCount }})
      </h2>
      <OapLoader v-if="showOverlay && !noLoader" />
      <button class="facets__closeButton" @click="closeFilterProductsDialog">
        <svg class="facets__toggleIcon" role="img" aria-hidden="true">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close" />
        </svg>
      </button>
      <button v-if="selectedFiltersCount > 0" class="facets__clearAll" @click="clearButtonClick">
        {{ initialData.dictionary.clearFacets }}
      </button>
    </div>
    <div class="filter-accordion__items">
      <template v-if="tagsData.tagsCollection.length > 0">
        <FilterFacet
          v-for="item in tagsData.tagsCollection"
          ref="filterFacet"
          :key="item.id"
          :title="item.title"
          :facets="item.facets"
          :is-loading="showOverlay"
        ></FilterFacet>
      </template>
    </div>
    <div class="filter-accordion__footer">
      <div class="filter-accordion__footer__wrapper">
        <button
          class="oap-button -primary oap-button__border clear-all"
          :class="{ '-disabled': showOverlay }"
        >
          <span class="oap-button__label" @click="clearButtonClick">
            {{ initialData.dictionary.clearFacets }}
          </span>
          <span>
            <svg role="img" aria-hidden="true" class="clearall__toggleIcon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
            </svg>
          </span>
        </button>
        <button
          class="oap-button -primary apply"
          :class="{ '-disabled': showOverlay }"
          @click="closeFilterProductsDialog"
        >
          <span class="oap-button__label">{{ initialData.dictionary.apply }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FilterFacet from './filter-facet';
import OapLoader from '../../../../OapLoader/code/Scripts/components/OapLoader.vue';
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'FilterAccordion',
  components: {
    FilterFacet,
    OapLoader,
  },
  props: {
    initialData: {
      type: Object,
      default: () => {},
    },
    showOverlay: {
      type: Boolean,
      default: false,
    },
    noLoader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('filterList', ['selectedFiltersCount', 'tagsData']),
    ...mapState('filterList', ['filterDataset']),
  },
  methods: {
    clearButtonClick() {
      eventBus.emit('resetFilterProducts', {
        apiURL: this.initialData.clearFilterApiUrl,
        url: this.initialData.clearFilterUrl,
      });
    },

    closeFilterProductsDialog() {
      eventBus.emit('closeFilterProductsDialog');
    },
  },
};
</script>
